import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private toaster: ToastrService) {}

  Success(title: string, message?: string) {
    this.toaster.success(message, title);
  }

  Warning(message?: string, title?: string) {
    this.toaster.warning(message, title);
  }

  Error(message?: string, title?: string) {
    this.toaster.error(message, title);
  }

  Info(message?: string, title?: string) {
    this.toaster.info(message, title);
  }
}
